var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "popup",
        attrs: { id: "popup_upload_photo" },
        on: {
          click: function($event) {
            return _vm.$store.commit("uploadPhoto", false)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "popup_block",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", {
              staticClass: "close",
              on: {
                click: function($event) {
                  return _vm.$store.commit("uploadPhoto", false)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pos_relative" }, [
              _c(
                "div",
                { staticClass: "img_load" },
                [
                  _c("vue-avatar", {
                    ref: "vueavatar",
                    attrs: {
                      width: 270,
                      height: 270,
                      rotation: _vm.rotation,
                      scale: _vm.scale,
                      id: "avatarEditor",
                      borderRadius: _vm.borderRadius,
                      image: _vm.image
                    },
                    on: { "vue-avatar-editor:image-ready": _vm.onImageReady }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "select-image" }, [
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.inputTrigerrClick()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("select")))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "block_roller" }, [
                _c("div", { staticClass: "div_relative" }, [
                  _c(
                    "div",
                    { staticClass: "roller" },
                    [
                      _c("div", { staticClass: "name_number" }, [
                        _c("div", { staticClass: "name_roller" }, [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$store.getters.t("Zoom")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "number_roller" }, [
                          _vm._v(_vm._s(_vm.scale.toFixed(1) + "x"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("vue-slider", {
                        attrs: { min: 1, max: 3, interval: 0.2 },
                        model: {
                          value: _vm.scale,
                          callback: function($$v) {
                            _vm.scale = $$v
                          },
                          expression: "scale"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "div_relative" }, [
                  _c(
                    "div",
                    { staticClass: "roller" },
                    [
                      _c("div", { staticClass: "name_number" }, [
                        _c("div", { staticClass: "name_roller" }, [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$store.getters.t("Rotation")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "number_roller" }, [
                          _vm._v(_vm._s(_vm.rotation.toFixed(1) + "°"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("vue-slider", {
                        attrs: { min: 0, max: 360 },
                        model: {
                          value: _vm.rotation,
                          callback: function($$v) {
                            _vm.rotation = $$v
                          },
                          expression: "rotation"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("input", {
                    staticClass: "submit_button",
                    attrs: { type: "submit" },
                    domProps: { value: _vm.$store.getters.t("save") },
                    on: { click: _vm.saveClicked }
                  })
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff82eb7a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff82eb7a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/avatar-editor.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ff82eb7a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/avatar-editor.vue
// module chunks = 0